import { useEffect, useRef } from 'react';

export default function FloatingBanner() {
  const bannerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleScroll = () => {
      if (bannerRef.current) {
        const scrollY = window.scrollY;
        bannerRef.current.style.transform = `translateY(${scrollY * 0.15}px)`;
      }
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div
      ref={bannerRef}
      className="fixed right-0 top-1/2 -translate-y-1/2 z-50 pointer-events-none select-none"
      style={{ writingMode: 'vertical-rl' }}
    >
      <span
        className="text-[11px] tracking-[0.35em] font-light"
        style={{
          color: 'rgba(180,160,120,0.5)',
          fontFamily: "'Cormorant Garamond', serif",
          letterSpacing: '0.35em',
        }}
      >
        ELEVATE YOUR ESSENCE
      </span>
    </div>
  );
}
